import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import "./styles/brand.css";
import "./styles/motion.css";
import { i18nReady } from "./i18n";

import { routeTree } from "./routeTree.gen";
import { registerServiceWorker } from "./components/notifications/push";

// Shows phone/tablet alerts (Web Push); no caching. See public/sw.js.
registerServiceWorker();

// "intent": hovering or focusing a link loads the target route's chunk and runs
// its loader, so most of the wait is over by the time the click lands.
const router = createRouter({ routeTree, defaultPreload: "intent" });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render once the active language's translations are in, so the first paint is
// never raw keys. Render even if that fetch failed: keys on screen beat a blank
// page, and a reload will usually fetch the bundle fine.
void i18nReady
  .catch(() => undefined)
  .then(() => {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <RouterProvider router={router} />
      </StrictMode>,
    );
  });
